import { AppState } from "@Store/index";
import { shallowEqual, useSelector } from "react-redux";

import Input from "@Components/Input";
import { getBudgetDurationAndCurrency } from "@Components/LeadForm/utils";
import { getPricingCurrency } from "@Pages/Search/components/SearchListItem/helper";
import styles from "../../../LeadFormModal/LeadFormModal.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const Budget = ({ error, setErrors, budget, setBudget, testIdPrefix }: any) => {
  const { inventory, inModal }: any = useSelector(
    ({ leadFormModal }: AppState) => leadFormModal,
    shallowEqual,
  );

  const country = inventory?.location?.country?.short_name;
  const { budget_duration_to_display } = getBudgetDurationAndCurrency(country);

  return (
    <Input
      value={budget}
      type="number"
      onChange={(e) => {
        setBudget(e);
        setErrors((errors: any) => ({ ...errors, budget: "" }));
      }}
      label={`${"Budget/person"} (${getPricingCurrency(
        inventory?.pricing?.currency,
      )}/${budget_duration_to_display})`}
      placeholder="Enter budget"
      containerClassName={inModal ? styles.budgetInput : styles.budgetSection}
      showErrorMessage={Boolean(error)}
      error={error}
      dataTestId={`${testIdPrefix}leadform-input-budget`}
      required
      id="budgetAccomodation"
    />
  );
};

export default wrapperHOC(Budget, {
  componentName: "Budget-dropdown-LeadForm-Global",
  showForChina: true,
});
